import styled from 'styled-components'

type AmountHandlerContainerProps = {
  isSmall?: boolean
}

export const AmountHandlerContainer = styled.div<AmountHandlerContainerProps>`
  width: 100%;
  /* height: ${({ isSmall }) => (isSmall ? '50px' : '58px')}; */
  height: 42px;
  color: ${({ theme }) => theme.FontColor};
  padding: 0 12px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: center;
`

export const AmountHandlerButton = styled('span')<any>`
  width: 42px;
  height: 42px;
  border-radius: 100%;
  /* background-color: ${({ theme }) => theme.colour}; */
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${({ theme, disabled }) =>
    disabled ? 'transparent' : theme.colour};
  border: ${({ disabled }) => (disabled ? '1px solid #cdcdcd' : 'unset')};
`

export const AmountHandlerCounter = styled.div`
  font-size: 20px;
  font-weight: 700;
  height: 100%;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
`

// QRM-524 dual-step layout: -coarse | -fine | value+unit | +fine | +coarse
// Grid with a FIXED centre column: the four buttons keep the same width whatever
// the value renders as (a flex centre sized by its content resized them on
// every step — "1 kg" vs "1.1 kg").
export const DualAmountContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 88px 1fr 1fr;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.FontColor};
`

export const DualStepButton = styled('button')<any>`
  width: 100%;
  min-width: 0;
  height: 56px;
  border-radius: 14px;
  border: 1px solid #cdcdcd;
  background: transparent;
  color: inherit;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  padding: 0 4px;
  opacity: ${({ disabled }) => (disabled ? 0.35 : 1)};
`

export const DualAmountValue = styled.div`
  font-size: 26px;
  font-weight: 700;
  white-space: nowrap;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;

  span {
    font-size: 15px;
    font-weight: 600;
    opacity: 0.6;
  }
`
